import { observable, toJS } from 'mobx';

export default class JobLogMessageModel {
    @observable id = null;
    @observable level = null;
    @observable timestamp = null;
    @observable identifier = null;
    @observable loggername = null;
    @observable jobguidkey = null;
    @observable title = null;
    @observable version = null;
    @observable message = null;

    constructor(id, level, timestamp, identifier, loggername, jobguidkey, title, version, message) {
        this.id = id;
        this.level = level;
        this.timestamp = timestamp;
        this.identifier = identifier;
        this.loggername = loggername;
        this.jobguidkey = jobguidkey;
        this.title = title;
        this.version = version;
        this.message = message;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(object) {
        return new JobLogMessageModel(
            object.id, object.level, object.timestamp, object.identifier, object.loggername,
            object.jobguidkey, object.title, object.version, object.message,
        );
    }
}
